import styled, { css } from "styled-components";
import Popover from "common/Popover/Popover";
import Flex from "common/Boxes/Flex";
import Title from "common/Typography/Title";
import {
  APPSTORE_DOWNLOAD_LINK,
  BOTTOM_NAVIGATOR,
  GENERIC_DOWNLOAD_LINK,
  GOOGLE_PLAY_DOWNLOAD_LINK,
} from "common/constants";
import React from "react";
import {
  AppQrCode,
  AppQrCodeIcon,
  AppStore,
  GooglePlay,
} from "common/Icons/Icons";

interface QrPopoverProps {
  isAppStore: boolean;
  isCollapsed?: boolean;
}

const QrPopover = ({ isAppStore, isCollapsed }: QrPopoverProps) => {
  const popoverContent = (
    <Flex $flexDirection="column" style={{ margin: "4px 0" }}>
      <StyledAppQrCode />
      <StyledTitle level={5}>
        Scan the QR code with your smartphone to download our app
      </StyledTitle>
      <Title level={5}>
        or{" "}
        <BoldLink onClick={() => window.open(getLink(), "_blank")}>
          Click Here
        </BoldLink>
      </Title>
    </Flex>
  );

  const getLink = () => {
    if (isCollapsed) return GENERIC_DOWNLOAD_LINK;
    if (isAppStore) return APPSTORE_DOWNLOAD_LINK;
    else return GOOGLE_PLAY_DOWNLOAD_LINK;
  };

  const getButton = () => {
    if (isCollapsed) return <StyledAppQrCodeIcon />;
    const logo = isAppStore ? <StyledAppStore /> : <StyledGooglePlay />;
    return <ButtonWrapper>{logo}</ButtonWrapper>;
  };

  return (
    <StyledPopover
      placement={isAppStore ? "topLeft" : "topRight"}
      showArrow={false}
      title={false}
      content={popoverContent}
      trigger="click"
      styles={{ root: { width: 225 } }}
    >
      {getButton()}
    </StyledPopover>
  );
};

export default QrPopover;

const StyledPopover = styled(Popover)`
  .ant-popover-inner-content {
    padding: 16px !important;
  }
`;
const StyledAppQrCode = styled(AppQrCode)`
  #qrCode path {
    fill: ${(p) => p.theme.colors.primaryGrey};
  }
  #arrow {
    fill: ${(p) => p.theme.colors.primaryBlue};
  }
  #frame {
    stroke: ${(p) => p.theme.colors.primaryBlue};
  }
  width: 190px;
  height: auto;
`;
const StyledTitle = styled(Title)`
  text-align: center;
  margin: 16px 0;
`;
const BoldLink = styled.span`
  cursor: pointer;
  color: ${(p) => p.theme.colors.primaryText};
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
  font-size: ${(p) => p.theme.typography.fontSizes.S};
`;
const DownloadButtonStyle = css`
  fill: ${(p) => p.theme.colors.secondaryGrey};
  cursor: pointer;
  width: 100%;
`;
const StyledAppStore = styled(AppStore)`
  ${DownloadButtonStyle}
  g path {
    fill: ${(p) => p.theme.colors.secondaryGrey};
  }
  @media (min-width: ${BOTTOM_NAVIGATOR}) {
    &:hover {
      g path {
        fill: ${(p) => p.theme.colors.primaryGrey};
      }
    }
  }
`;
const StyledGooglePlay = styled(GooglePlay)`
  ${DownloadButtonStyle};
  @media (min-width: ${BOTTOM_NAVIGATOR}) {
    &:not(:hover) {
      g path {
        fill: ${(p) => p.theme.colors.secondaryGrey};
      }
    }
  }
  @media (max-width: ${BOTTOM_NAVIGATOR}) {
    g path {
      fill: ${(p) => p.theme.colors.secondaryGrey};
    }
  }
`;
const StyledAppQrCodeIcon = styled(AppQrCodeIcon)`
  width: 18px;
  cursor: pointer;
  margin: 16px auto 16px 13px;
  color: ${(p) => p.theme.colors.primaryGrey};
  &:hover {
    color: ${(p) => p.theme.colors.primaryBlue};
  }
`;
const ButtonWrapper = styled.div`
  border: ${(p) => p.theme.borders.light};
  border-radius: 6px;
  width: 100%;
  height: 34px;
`;
